import { useEffect, useRef, useState } from "react";

import api from "../../services/api";

// Lazily fetches GET /isp/invoice-campaigns/:id for the campaign ids shown on
// screen (runs drawer / last-run column) so sent/failed can be displayed.
// Failures are silent: the caller shows "–" for unknown counters.
const useCampaignTotals = (ids) => {
  const [campaigns, setCampaigns] = useState({});
  const inFlight = useRef(new Set());
  const key = (ids || []).filter(Boolean).map(String).sort().join(",");

  useEffect(() => {
    if (!key) {
      inFlight.current.clear();
      setCampaigns((prev) => (Object.keys(prev).length ? {} : prev));
      return undefined;
    }
    let active = true;
    const missing = key.split(",").filter((id) => !campaigns[id] && !inFlight.current.has(id));
    missing.forEach((id) => inFlight.current.add(id));
    missing.forEach(async (id) => {
      try {
        const { data } = await api.get(`/isp/invoice-campaigns/${id}`);
        if (active && data) setCampaigns((prev) => ({ ...prev, [id]: data }));
      } catch (err) {
        // silent: counters stay unknown
      } finally {
        inFlight.current.delete(id);
      }
    });
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return campaigns;
};

export default useCampaignTotals;
